import soilDataConfigApi from '@/api/config/soilDataConfigApi'
import { queryKeys } from '@/constant/common'
import { CreateSoil } from '@/types/soil'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function create(payload: CreateSoil): Promise<void> {
  await soilDataConfigApi.create(payload)
}

function useAddSoil() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: CreateSoil) => create(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.soil])
      toast.success(t('addSoilSuccessfully'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 404) {
        toast.error(error?.message)
      } else toast.error(t('addSoilError'))
    },
  })

  // return mutate
}

export default useAddSoil
